/**
 * 采集原始事件类型定义枚举
 */
enum EVENT_MSG_TYPE {
  PAGEVIEW = 'pageview',
  PAGECLOSE = 'pageclose',
  JSERROR = 'jserror',
  CONSOLEERROR = 'consoleerror',
  XHR = 'xhr',
  FETCH = 'fetch',
  UNHANDLEDREJECTION = 'unhandledrejection', // unhandledrejection
  CLICK = 'click',
  RESOURCE = 'RESOURCE',
  COUNT = 'count',
  OTHER = 'other',
  CUSTOM = 'custom',
  BIZOP = 'bizop',
}

export default EVENT_MSG_TYPE;
